export default __webpack_public_path__ + "static/media/plus.6cf6cbf4.svg";